export default function getRootUrl(req) {
  const port = process.env.APIPORT || 3333;
  const ROOT_URL = process.env.NODE_ENV == 'production' ?  `https://feedbackchat.hlthclub.in` : `https://betafeedbackchat.hlthclub.in`;
  //const ROOT_URL = process.env.prod_url;
  console.log(`Env: ${process.env.NODE_ENV} AND ROOT_URL: ${ROOT_URL}`);
  return ROOT_URL;
}


// WEBPACK FOOTER //
// lib/api/getRootUrl.ts